/* eslint-disable @typescript-eslint/no-explicit-any */

import styled, { css, keyframes } from 'styled-components';
import { palette } from 'styled-tools';

const Animation1 = keyframes`
  0% {
    transform: scale(1) translateX(0%) translateX(50%) translateY(0);
    opacity: 0.5;
  }

  50% {
    transform: scale(1.15) translateX(0) translateX(25%) translateY(-5%);
    opacity: 0.9;
  }

  100% {
    transform: scale(1) translateX(0) translateX(0) translateY(0);
    opacity: 0.5;
  }
`;

const Animation2 = keyframes`
  0% {
    transform: scale(1) translateX(-50%) translateY(0);
    opacity: 0.5;
  }

  50% {
    transform: scale(0.85) translateX(-25%) translateY(5%);
    opacity: 0.4;
  }

  100% {
    transform: scale(1) translateX(0) translateY(0);
    opacity: 0.5;
  }
`;

const circle1Animation = css`
	${Animation1} 1s linear infinite;
`;

const circle2Animation = css`
	${Animation2} 1s linear infinite;
`;

// The scale/opacity pulse is purely decorative, so users who request reduced motion get a
// static circle rather than a continuously animating one; the "loading" announcement still fires.
const reducedMotion = css`
	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

export const Circle1 = styled.circle`
	animation: ${circle1Animation};
	${reducedMotion}
`;

export const Circle2 = styled.circle`
	animation: ${circle2Animation};
	${reducedMotion}
`;

export const Wrapper = styled.svg<{ color: string }>`
	height: 100%;
	padding: 0;
	margin: 0 auto;
	display: block;
	width: 160px;

	circle {
		fill: ${(props): any => palette(props.color)};
		opacity: 0.5;
	}
`;
